import styled from "styled-components";

export const Select = styled.select`
  background-color: ${(props) => props.theme.colors.background};
  border: none;
  border-radius: 24px;
  padding: 0.8rem 1rem;
  font-size: 14px;

  :focus {
    border: none;
    outline: none;
  }
  
  & > svg {
    padding-right: 2rem;
    
  }
`;